import {Box, Chip, Fade, Typography} from "@mui/material";
import React from "react";
import LogoImage from '../assets/logo.svg';
import EbayLogo from '../assets/ebay-rightnow-vert.png';
import {MobileTooltip} from "./Tooltip";
import {Affiliate} from "./Affiliate";
const Logo = React.memo(LogoBase);
function LogoBase({total, items, loading, goHome, user}) {
    return (
        ((items !== 0 || !loading)) &&
        <Fade in>
            <Box
                display="flex"
                justifyContent="left"
                alignItems="center"
                width="100%"
                sx={{userSelect: 'none', maxWidth: '1024px', margin: '0 auto', padding: '0 12px'}}
            >
                <MobileTooltip enterDelay={500} title={"Home"} placement={"right"}>
                    <div style={{display: "flex", alignItems: "center", cursor: "pointer"}} onClick={goHome}>
                        <img style={{overflow: "visible"}} onClick={goHome}
                             src={LogoImage} id='logo'
                             alt={'logo'}/>
                        <Typography onClick={goHome} variant={'h5'} sx={{
                            fontSize: "21px",
                            letterSpacing: "-0.5px",
                            fontFamily: "'IBM Plex Sans', 'Roboto'",
                            cursor: "pointer"
                        }}>sidebae</Typography>
                    </div>
                </MobileTooltip>
                <Fade in={items !== 0}>
                    <Box
                        display="flex"
                        justifyContent="right"
                        alignItems="center"
                        width="100%"
                        sx={{userSelect: 'none'}}
                    >
                        <>
                            {!user && <Affiliate />}
                            <MobileTooltip enterDelay={500} title={"Visit eBay"} placement={"left"}>
                                <a style={{marginRight: '6px', marginTop: "0.2px"}} href={'https://www.ebay.com'}
                                   target="_blank"
                                   rel="noopener noreferrer">
                                    <img width={'59px'} src={EbayLogo} id='ebay-logo'
                                         alt={'ebay-logo'}/>
                                </a>
                            </MobileTooltip>
                        </>
                        <MobileTooltip sx={{maxWidth: "10px"}} enterDelay={500}
                                       title={"Current count of global listing search results. As you scroll, sidebae interweaves listings from 12 different eBay locales, so this count may increase."}>
                            <Chip sx={{fontSize: '0.75em'}} label={total} variant="outlined"/>
                        </MobileTooltip>
                    </Box>
                </Fade>
            </Box>
        </Fade>
    )

}

export default Logo;